import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '姐姐的朋友 - 首页',
    description: '「姐姐的朋友」是你打开优质社交圈子的最佳切入点。深度解析如何通过姐姐的朋友拓展人脉、建立信任关系。',
    url: 'https://jiejiefriends.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '姐姐的朋友',
      url: 'https://jiejiefriends.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}